<template>
  <div v-if="isDraw" class="vz-print fs-16">
    <div class="vz-print-column">
      <div>
        <img src="https://vozovoz.ru/assets/build/images/01_1.png?v=2" height="31">
      </div>
      <div class="head-top-locations">
        <h4 class="group-label">
          <span class="tnr">{{ locationsTitle.from }}</span>
          <img src="https://vozovoz.ru/assets/build/images/car.png?v=1">
          <span class="tnr">{{ locationsTitle.to }}</span>
        </h4>
      </div>
      <div class="group-cargo tnr">
        <span class="tnr">Объем:<span class="tnr">&nbsp;{{ cargoGeneralVolume }}м³</span></span>
        <span class="tnr">Вес:<span class="tnr">&nbsp;{{ cargoGeneralWeight }}кг.</span></span>
      </div>
      <div v-if="isDimensionMode" class="max-gub tnr">
        Максимальные параметры груза(Д х Ш х В):
        <span class="tnr">&nbsp;{{ getCargoDetails('length') }}м&nbsp;x&nbsp;{{ getCargoDetails('width') }}м&nbsp;x&nbsp;{{ getCargoDetails('height') }}м</span>&nbsp;&nbsp;&nbsp;Вес: <span class="tnr">&nbsp;{{ getCargoDetails('weight') }}кг.</span>
      </div>
      <hr>
      <div class="group-service">
        <div v-for="(service, index) of services" :key="index" class="group-service-line">
          <span class="group-service-line-title">{{ service.title }}</span>
          <span class="group-service-line-dotted" />
          <span class="group-service-line-cost">{{ service.cost }}&nbsp;{{ orderCurrency }}</span>
        </div>
        <div v-if="discount.title" class="group-service-line">
          <span class="group-service-line-title">{{ discount.title }}</span>
          <span class="group-service-line-dotted" />
          <span class="group-service-line-cost">{{ discount.cost }}&nbsp;{{ orderCurrency }}</span>
        </div>
        <div v-if="price" class="group-service-line mt-40">
          <span class="group-service-line-title fs-22">Стоимость заказа</span>
          <span class="group-service-line-dotted" />
          <span class="group-service-line-cost fs-22">{{ price }}&nbsp;{{ orderCurrency }}</span>
        </div>
      </div>
      <div class="mt-50 fs-14 tnr">
        Расчет стоимости актуален на {{ currentDate }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {formatDate} from '~/common/date';
import {convertPriceServices, getCurrencyText, priceDataToOrderForm, pricePayload} from '~/common/objects';
import {getOrderCalculation, getOrderPrice} from '~/api/order';

definePageMeta({
  layout: 'empty',
})

const { $showToast } = useNuxtApp()

const isDraw = ref(false)
const order = ref(null)
const discount = ref({
  title: '',
  cost: ''
})
const locationsTitle = ref({
  from: '',
  to: ''
})
const cargoGeneralVolume = ref(0)
const cargoGeneralWeight = ref(0)

const currency = ref('RU')
const services = ref([])

const currentDate = computed(() => {
  return formatDate(new Date())
})

const price = computed(() => {
  return services.value.reduce((sum, arr) => sum += arr.cost, 0)
})

const orderCurrency = computed(() => {
  return getCurrencyText(currency.value)
})

const isDimensionMode = computed(() => {
  return order.value?.cargo?.mode === 'dimension' && !order.value?.cargo?.wizardUsed
})

function getCargoDetails(type: string): number {
  if (order.value?.cargo?.dimension?.detail?.[type]) {
    return order.value.cargo.dimension.detail[type]
  }
  return 0
}

onBeforeMount(async () => {
  const calculationHash = useRoute().query.calculation as string
  currency.value = useRoute().query?.currency as string || 'RU'
  order.value = await getOrderCalculation(calculationHash)
  locationsTitle.value = {
    from: order.value?.gateway?.dispatch?.location.title,
    to: order.value?.gateway?.destination?.location.title
  }
  const orderForm = priceDataToOrderForm(order.value)
  orderForm.currency = currency.value
  const payload = pricePayload(orderForm)
  const price = await getOrderPrice(payload)
  if (price?.error) {
    $showToast({
      variant: 'primary',
      title: 'Уведомление',
      text: price?.error?.opt?.message?.description || price?.error?.opt?.message?.message || price?.error?.message
    })
    return
  }
  services.value = convertPriceServices(price)
  discount.value = {
    title: price.cost.action,
    cost: price.cost.discount
  }
  cargoGeneralVolume.value = payload.cargo?.dimension.general?.volume || 0
  cargoGeneralWeight.value = payload.cargo?.dimension?.general?.weight || 0

  isDraw.value = true
})
</script>

<style lang="scss" scoped>
.tnr {
  font-family: 'Times New Roman', Times, serif !important;
}
.vz-print {
  display: flex;
  flex-direction: column;
  align-items: center;

  .vz-print-column {
    width: 773px;
    padding: 16pt 10pt;
    .head-top-locations {
      font-family: inherit;
      .group-label {
        margin-top: 30px;
        font-size: 22pt;
        display: flex;
        flex: 1 1 100%;
        align-items: center;
        justify-content: center;
        font-family: inherit;
        span {
          font-size: 29px;
          margin-top: 29px;
          font-weight: bold;
          font-family: inherit;
        }
        img{
          width: 40px;
          height: 30px;
          margin: 0 20px;
          margin-top: 29px;
          font-family: inherit;
        }

      }
    }
    .group-cargo {
      font-family: inherit;
      display: flex;
      font-size: 16px;
      margin-top: 10px;
      span:first-child {
        font-family: inherit;
        margin-right: 15px;
        font-size: 16px;
      }
    }
    .group-service {
      &-line {
        display: flex;
        flex: 1 1 100%;
        line-height: 15px;
        margin-bottom: 10px;
        font-family: 'Times New Roman', Times, serif;
        &-title {
          font-family: inherit;
          line-height: 15px;
        }
        &-cost {
          font-family: inherit;
          line-height: 15px;
        }
        &-dotted{
          flex-grow: 1;
          border-bottom: 1px dotted;
          font-family: inherit;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
